"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Check, Send } from "lucide-react"

/** Shared with the mobile registration plan list, which renders the same offer. */
export const ENTERPRISE_BENEFITS = [
  "Custom usage and agent limits",
  "Tailored onboarding and integrations",
  "Priority support",
]

export const ENTERPRISE_TAGLINE = "A plan designed around your business."

export function EnterprisePlanCard({ onSelect }: { onSelect: () => void }) {
  return (
    <Card
      role="button"
      tabIndex={0}
      aria-label="Contact sales about the Enterprise plan"
      className="relative flex cursor-pointer flex-col transition-all hover:border-blue-400 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
      onClick={onSelect}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault()
          onSelect()
        }
      }}
    >
      <CardHeader className="pb-3">
        <CardTitle className="text-lg">Enterprise</CardTitle>
        <p className="mt-1 text-3xl font-bold">Custom</p>
        <p className="text-sm text-muted-foreground">{ENTERPRISE_TAGLINE}</p>
      </CardHeader>
      <CardContent className="flex flex-1 flex-col gap-4">
        <div className="space-y-3">
          {ENTERPRISE_BENEFITS.map((benefit) => (
            <div key={benefit} className="flex items-start gap-2 text-sm">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-green-500" />
              <span>{benefit}</span>
            </div>
          ))}
        </div>
        <div className="mt-auto flex items-center justify-center gap-2 rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white">
          <Send className="h-4 w-4" />
          <span>Contact sales</span>
        </div>
      </CardContent>
    </Card>
  )
}
